import { ApplicationInvoiceFormData } from "../../../hooks/useApplicationInvoice";
import { Grid, TextField } from "@mui/material";

interface InvoiceDataFormProps {
  formData: ApplicationInvoiceFormData;
  formErrors: Record<string, string>;
  isSaving: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Konfiguracja pól formularza faktury
 */
const INVOICE_FORM_FIELDS = [
  { name: "invoiceName", label: "Nazwa firmy/instytucji", required: true },
  { name: "invoiceTaxId", label: "NIP", required: true },
  { name: "invoicePostalCode", label: "Kod pocztowy", required: true },
  { name: "invoiceCity", label: "Miasto", required: true },
] as const;

/**
 * Komponent formularza danych faktury
 * Zgodny z zasadą pojedynczej odpowiedzialności - tylko formularz
 */
export default function InvoiceDataForm({
  formData,
  formErrors,
  isSaving,
  onChange,
}: InvoiceDataFormProps) {
  return (
    <Grid container spacing={2}>
      {/* Pola z konfiguracji */}
      {INVOICE_FORM_FIELDS.map((field) => (
        <Grid item xs={12} sm={6} key={field.name}>
          <TextField
            fullWidth
            name={field.name}
            label={field.label}
            type="text"
            required={field.required}
            value={formData[field.name as keyof ApplicationInvoiceFormData] || ""}
            onChange={onChange}
            helperText={formErrors[field.name]}
            error={!!formErrors[field.name]}
            size="small"
            disabled={isSaving}
          />
        </Grid>
      ))}

      {/* Pola adresu - specjalny layout (ulica + numer domu + lokal) */}
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          name="invoiceStreet"
          label="Ulica"
          type="text"
          required
          value={formData.invoiceStreet || ""}
          onChange={onChange}
          helperText={formErrors.invoiceStreet}
          error={!!formErrors.invoiceStreet}
          size="small"
          disabled={isSaving}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          fullWidth
          name="invoiceHouseNumber"
          label="Numer domu"
          type="text"
          required
          value={formData.invoiceHouseNumber || ""}
          onChange={onChange}
          helperText={formErrors.invoiceHouseNumber}
          error={!!formErrors.invoiceHouseNumber}
          size="small"
          disabled={isSaving}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          fullWidth
          name="invoiceLocalNumber"
          label="Numer lokalu"
          type="text"
          value={formData.invoiceLocalNumber || ""}
          onChange={onChange}
          helperText={formErrors.invoiceLocalNumber}
          error={!!formErrors.invoiceLocalNumber}
          size="small"
          disabled={isSaving}
        />
      </Grid>
    </Grid>
  );
}
